import dayjs, { type Dayjs } from 'dayjs'
import type { SessionInfoResponse } from '../types'

/** `90` → `1h 30m`, `45` → `45m`, `720` → `12h`. */
export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  if (h === 0) return `${m}m`
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}

/** Session length in whole minutes; `0` for open-ended entries (unmatched incidents). */
export function sessionDuration(s: { startTime: string; endTime?: string }): number {
  if (!s.endTime) return 0
  return Math.round(dayjs(s.endTime).diff(dayjs(s.startTime), 'minute'))
}

/** Stable identity for a session row — orphan incident buckets have no `sessionId`. */
export function sessionKey(s: SessionInfoResponse): string {
  return s.sessionId ?? s.startTime
}

/** Monday-based start of the week containing `d`. */
export function startOfWeekMonday(d: Dayjs): Dayjs {
  return d.startOf('day').subtract((d.day() + 6) % 7, 'day')
}
